import React, { useEffect, useMemo, useState, useContext } from 'react';
import MUIDataTable from "mui-datatables";
import { Checkbox, Grid, IconButton, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import rest from '../../rest';
import MultiModal from '../../components/general/modals/multiOptModal';
import PopperTipsBenevol from '../../components/cards/PopperTipBenev';
import GetRandomKey from '../../components/general/genereRandomKey';
import LoadingIndicator from '../../components/loadingIndicator/LoadingIndicator';
import { useModal } from '../../components/general/modalContext';
import textLabels from '../../components/dataTable/textLabel';
import { MySnackbar } from '../../components/mySnackbar/MySnackbar';
import InfosBenevole from '../../components/infosBenevole/InfosBenevole';
import { useSelector } from 'react-redux';
import FormulaireInscription from '../../components/formulaire/FormulaireInscription';
import { formatTimeToDate, dateToDateAge } from '../../components/general/formateDate';
import useRedirectAndReload from '../../components/general/redirectReload';
import AppContext from "../../components/appContext";
import ButtonStyled from '../../components/general/ButtonStyled';
import { useLocation } from 'react-router-dom';

const UserDoublon = () => {
    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const { openModal, closeModal } = useModal();
    const [snack, setSnack] = useState({});
    const [currentRow, setCurrentRow] = useState([]);
    const [openFicheUser, setOpenFicheUser] = useState(false);
    const currentUser = useSelector(state => state.user);
    const currentManif = useSelector(state => state.manif)
    const [storageDoublon, setStorageDoublon] = useState([]);
    const [reloadCache, setReloadCache] = useState(false);
    const redirectAndReload = useRedirectAndReload({ url: "/les_benevoles.html", typeLink: "fromDoublon" });
    const myContext = useContext(AppContext);
    const openSidebar = myContext.openSidebar;

    const location = useLocation();
    const { typeLink } = location?.state || '';
    useEffect(() => {
        if (typeLink === "recufromTab") {
            setReloadCache(r => !r);
        }
    }, [typeLink]);

    const customTheme = {
        overrides: {
            MUIDataTable: {
                paper: {
                    paddingTop: '40px', // Hauteur maximale du conteneur
                    overflow: 'visible', // Ajoutez cette ligne pour spécifier l'overflow
                },
            },
        },
    };

    const trendyColors = [
        "#FF6F61", // Melon
        "#5E72E4", // Bleu Royal
        "#F9D56E", // Jaune Moutarde
        "#56CCF2", // Bleu Céleste
        "#FF9F43", // Orange Pastel
        "#2D98DA", // Bleu Cobalt
        "#FFD700", // Or
        "#FF6384", // Rose Flamant
        "#00D1A0", // Vert Émeraude
        "#F783AC"  // Rose Doux
    ];

    const getColorByGroup = (groupNumber) => {
        if (trendyColors.length === 0)
            return "#FF6F61";

        const index = +groupNumber % trendyColors.length;
        return trendyColors[index];
    };

    useEffect(() => {
        const param = {};
        if (localStorage.getItem('doublon')) {
            setStorageDoublon(JSON.parse(localStorage.getItem('doublon')));
            // Requete avec les parametres
            if (JSON.parse(localStorage.getItem('doublon')).length > 1) {
                param.listeUser = JSON.parse(localStorage.getItem('doublon'));
            }
        }

        if (reloadCache) {
            param.supprimeChache = 'true';
            setReloadCache(false);
            setStorageDoublon([]);
        }
        setLoading(true);
        rest.post('/benevols/listeDoublon.json', JSON.stringify(param))
            .then(function (response) {
                setUsersData(response.data);
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });

    }, [reloadCache]);

    useEffect(() => {
        if (storageDoublon.length > 1) {
            setSelectedRows(usersData.map((_, index) => index));
        }
    }, [storageDoublon, usersData]);

    const sortUser = useMemo(() => {
        const sortUser = selectedRows.map(index => usersData[index]).sort((a, b) => b.ID - a.ID);
        return sortUser;
    }, [selectedRows, usersData])


    const sendForFusion = () => {
        const usersToFusion = sortUser;
        const referenceUser = usersToFusion[0];
        const params = { usersToFusion, referenceUser };
        rest.post('/benevols/verifConflictsFusion.json', encodeURIComponent(JSON.stringify(params)))
            .then(function (response) {
                const intersection = response.data?.intersection;
                const conflit = response.data?.conflit;
                const fusion = response.data?.fusion;
                const error = response.data?.error;
                if (conflit !== undefined && Object.keys(conflit).length > 0) {
                    const modalOption = [];
                    modalOption.push({ null: true }); // pour aligner a droite le bouton suivant on ajoute un espace vide 
                    modalOption.push({ handle: closeModal, color: "primary", text: "Fermer", variant: 'outlined' });
                    let text = ``;
                    for (const prop in conflit) {
                        if (conflit.hasOwnProperty(prop) && conflit[prop].length > 0) {
                            let index;
                            switch (prop) {
                                case 'Groups':
                                    index = intersection.filter(obj => obj.type === "Membres_Groupe").map(group => usersToFusion.findIndex(obj => obj.ID === group.ID_Person) + 1);
                                    text += ` - Les profils (${[...new Set(index)].join(', ')}) sont chacun inscrits dans au moins un groupe.
                                    `;
                                    break;
                                case 'Tranches':
                                    index = intersection.filter(obj => obj.type === "Person_Tranche")
                                        .map(tranche => usersToFusion.findIndex(obj => obj.ID === tranche.ID_Person) + 1);
                                    text += ` - Les profils (${[...new Set(index)].join(', ')}) sont chacun inscrits à au moins une activité.
                                    `;
                                    break;
                                case 'WishList':
                                    index = intersection.filter(obj => obj.type === "Person_WishList")
                                        .map(tranche => usersToFusion.findIndex(obj => obj.ID === tranche.ID_Person) + 1);
                                    text += ` - Les profils (${[...new Set(index)].join(', ')}) possèdent chacun une liste de souhaits.
                                        `;
                                    break;
                                case 'Responsable':
                                    index = intersection.filter(obj => obj.type === "Person_Responsable")
                                        .map(tranche => usersToFusion.findIndex(obj => obj.ID === tranche.ID_Person) + 1);
                                    text += ` - Les profils (${[...new Set(index)].join(', ')}) sont chacun responsable d'activité.
                                            `;
                                    break;
                                case 'Profile':
                                    index = intersection.filter(obj => obj.type === "Profile").map(prof => usersToFusion.findIndex(obj => obj.ID === prof.user_id) + 1);
                                    text += ` - Les profils (${[...new Set(index)].join(', ')}) possèdent chacun un compte utilisateur (compte en ligne du bénévole).
                                    `;
                                    break;

                                default:
                                    console.log('fusion doublon - ca na pas switcher ==============>>>>>>>>>>>>>>> ');
                                    break;
                            }
                        }
                    };
                    if (text !== '') {
                        text += `
                        <p className="bottomLigneCenter"> </p>Un seul profil peut être inscrit à une/des activité/s, être responsable d'activité, posséder un compte utilisateur${currentManif?.manifParams?.InscripionWishlist ? ', avoir une liste de souhaits ' : ''} ou être inscrit dans un groupe. 
                        Veuillez vous rendre sur la fiche bénévole des profils mentionnés pour résoudre le(s) conflit(s) avant de procéder à la fusion.`;
                    }

                    text += `  \n`;
                    openModal("Fusion impossible, veuillez résoudre le(s) conflit(s) suivant(s)  ",
                        <MultiModal text={text} options={modalOption} />);
                }

                if (fusion !== undefined && fusion !== '') {

                    openModal("Veuillez cliquer sur un champ pour sélectionner l'élément souhaité",
                        <div style={{ padding: '0', maxHeight: '90vh' }}>
                            <FormulaireInscription
                                idBenevole={referenceUser.ID}
                                setSnack={setSnack}
                                fromDoublon={true}
                                row={Array.isArray(selectedRows) ? usersToFusion : []}
                                setShowForm={closeModal}
                                setReloadCache={setReloadCache}
                            />
                        </div>)
                }

                if (error) {
                    setSnack({ message: error, show: true, severity: "error" });
                }

            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    }

    const ficheBenevole = () => {
        return (
            <InfosBenevole readOnly={currentUser?.User?.User_Administrator ? false : true}
                idBenevole={currentRow[1]}
                benevSelectedName={currentRow[3]}
                benevSelectedFirstName={currentRow[4]}
                handleClose={closeFiche} />
        )
    }

    const closeFiche = () => {
        setOpenFicheUser(false);
    }

    const columns = [
        {
            name: "checkbox",
            label: "Sélection",
            options: {
                customBodyRenderLite: (dataIndex) => (
                    <Checkbox
                        checked={Array.isArray(selectedRows) ? selectedRows.includes(dataIndex) : false}
                        onChange={() => handleRowSelection(dataIndex)}
                    />
                ),
                sort: false,
            },
        },
        {
            name: "ID",
            label: "ID",
            options: {
                display: true,
            },
        },
        {
            name: "person_profil",
            label: "Dernière connexion",
            options: {
                customBodyRender: (value, row) => {
                    if (value && value.length > 0 && value[0].profil_user && value[0].profil_user.Derniere_Connexion) {
                        const timestamp = value[0].profil_user.Derniere_Connexion;
                        const formattedDate = formatTimeToDate(timestamp, 'small');
                        return formattedDate;
                    } else {
                        return "non défini";
                    }
                }
            }
        },
        {
            name: "Name",
            label: "Nom",
            options: {
                sortThirdClickReset: true,
                customBodyRender: (value, row) => {
                    const randKey = GetRandomKey(9);
                    const name = value + ' ' + row.rowData[4];
                    const handleClick = () => {
                        setCurrentRow(row.rowData);
                        setOpenFicheUser(true);
                    };
                    return (
                        <div onClick={handleClick}>
                            <PopperTipsBenevol idBenevole={row.rowData[1]} person={null} text={name} componentKey={randKey} showEdit={false} />
                        </div>
                    );
                },
            }
        },
        {
            name: "Firstname",
            label: "Prénom",
            options: {
                display: false, // Cette propriété permet de masquer la colonne
            },
        },
        {
            name: "Address",
            label: "Addresse",
        },
        {
            name: "Phone_Mobile",
            label: "Téléphone",
        },
        {
            name: "Birth",
            label: "Date de naissance",
            options: {
                filter: false,
                sortThirdClickReset: true,
                customBodyRender: (value) => {
                    let dateFormatee = "";
                    if (value !== "0000-00-00T00:00:00.000Z") {
                        dateFormatee = dateToDateAge(value);
                    }
                    return dateFormatee;
                }
            },
        },
        {
            name: "Email",
            label: "Email",
        },
        {
            name: "groupe",
            label: "Groupe",
            options: {

                setCellProps: (value) => ({
                    className: 'custom-cell',
                    style: { border: `solid 1rm ${getColorByGroup(value)}` },
                }),
                customBodyRender: (value) => (
                    <div style={{ backgroundColor: getColorByGroup(value), padding: '8px', borderRadius: '4px', width: '10px', height: '20px', margin: '0 auto' }}>
                        {''}
                    </div>
                ),
                customSort: (data, colIndex, order) => {
                    return data.sort((a, b) => {
                        const aValue = a.data[colIndex].props.children;
                        const bValue = b.data[colIndex].props.children;

                        if (order === 'asc') {
                            return aValue.localeCompare(bValue);
                        } else {
                            return bValue.localeCompare(aValue);
                        }
                    });
                },
            },
        },

    ];

    const options = {
        search: true,  // Désactive l'icône de recherche
        filter: false,  // Désactive l'icône de filtre
        download: false,  // Désactive l'icône de téléchargement/export
        print: false,  // Désactive l'icône d'impression
        viewColumns: false,  // Désactive l'icône de vue des colonnes
        selectableRowsHeader: false,  // Désactive la case à cocher de sélection globale
        selectableRowsHideCheckboxes: true,  // Cache les cases à cocher de sélection individuelles
        selectableRows: 'none',
        onRowSelectionChange: (currentRowsSelected) => setSelectedRows(currentRowsSelected),
        customTheme,
        // sort: false,
        textLabels: textLabels,
        customToolbar: () => {
            return (
                <div>
                    {selectedRows.length > 1 && <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '8px' }}>
                        <ButtonStyled onClick={() => handleFusionButtonClick()} variant="contained" color="primary" size='medium'>Choisir les données à fusionner...</ButtonStyled>
                    </div>}
                    <Tooltip title={`Les profils sont considérés comme des doublons si l'une des conditions suivantes est remplie : 
                            les noms sont identiques et les prénoms sont identiques ou similaires, les noms et les dates de naissance sont identiques, 
                            les numéros de téléphone sont identiques.`}>
                        <IconButton aria-label="info">
                            <InfoIcon />
                        </IconButton>
                    </Tooltip>
                    <div style={{ textAlign: 'left', paddingBottom: '10px', padding: '5px 25px', position: 'absolute', width: '100%', left: '0' }}>
                        <p>{`Veuillez sélectionner les profils à fusionner. Plus le nombre de l'ID est grand, plus la création du profil est récente. 
                        En cliquant sur "Choisir les données à fusionner", vous pourrez choisir quelles données conserver parmi celles des différents profils. 
                        Un seul profil peut être inscrit à une activité ou être responsable, posséder un compte utilisateur ou être membre d'un groupe 
                        (fonctionnalité en option) pour procéder à la fusion. Le profil fusionné héritera de ces attributs s'ils sont renseignés.`}
                        </p>
                    </div>
                </div>
            );
        },
    };

    const handleFusionButtonClick = () => {
        sendForFusion();
    }


    const handleRowSelection = (dataIndex) => {
        const newSelectedRows = [...selectedRows];
        if (newSelectedRows.includes(dataIndex)) {
            newSelectedRows.splice(newSelectedRows.indexOf(dataIndex), 1);
        } else {
            newSelectedRows.push(dataIndex);
        }
        setSelectedRows(newSelectedRows);
    };

    const hundelEmptyStorage = () => {
        localStorage.setItem('doublon', []);
        setSelectedRows([]);
        redirectAndReload();
        setOpenFicheUser(false);
        closeFiche(false);
    }

    const handlevVideCache = () => {
        setReloadCache(true);
    }

    return (
        <div>
            <LoadingIndicator open={loading} />
            <MySnackbar params={snack} />
            <Grid container alignItems="center" justifyContent="space-between" spacing={2} style={{ marginBottom: '20px' }}>
                {storageDoublon.length > 0 && <Grid item>
                    <ButtonStyled
                        variant="contained"
                        color="secondary"
                        style={{ width: '193px' }} // Alignement du bouton "vider la selection"
                        size="medium"
                        onClick={hundelEmptyStorage}
                    >
                        Vider la sélection
                    </ButtonStyled>
                </Grid>}

                <Grid item>
                    {!localStorage.getItem('doublon') && <ButtonStyled
                        variant="contained"
                        color="warningBtn"
                        size="medium"
                        style={{ width: '193px' }} // Alignement du bouton "vider la selection"
                        onClick={handlevVideCache}
                    >
                        Regénérer la liste
                    </ButtonStyled>}

                </Grid>
            </Grid>

            {storageDoublon.length < 1 && (
                <MUIDataTable
                    title={"Doublons"}
                    data={usersData}
                    columns={columns}
                    options={options}
                    className={`DataTableProperTips ${selectedRows.length < 5 ? 'owerflowNone' : ''} toplarge ${openSidebar ? '' : 'noSideBar'}`}
                />
            )}

            {openFicheUser && ficheBenevole()}
        </div>
    );

};

export default UserDoublon;
